An array of identifiers for the position's `Location`s.

A maximum of 1 location may be provided.
